<template>
    
    <div v-if="$route.name === 'Join2Intro'">
        <Join2Intro></Join2Intro>
    </div>
    <div v-else-if="$route.name === 'Join2ExistSocial'">
        <!-- {{$route.name}} -->
        <Join2ExistSocial></Join2ExistSocial>
    </div>
    
    <section class="d-flex flex-column h-full bg-white" v-else>
        <!-- {{$route.name}} -->
        <TopAppBar
            :leftBtnMode="leftBtnMode"
            :rightBtnMode="rightBtnMode"
            :title="title"
            :leftBtnMethod="leftBtnMethod"
            :rightBtnMethod="rightBtnMethod"
            :staticMode="staticMode"
        >
        </TopAppBar>
        <div class="flex-grow-1 scroll-y">
            <router-view></router-view>
        </div>
            
        
    </section>

    
</template>

<script>
/**
 * 회원가입 메인 컴포넌트(sign up main component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import TopAppBar from '@/components/TopAppBar.vue'
import Join2Intro from '@/components/join2/Intro.vue'
import Join2ExistSocial from '@/components/join2/ExistSocial.vue'
import {topAppBarMixin} from '../mixins/topAppBar.js'
export default {
    name: '',
    components: {
        TopAppBar, Join2Intro, Join2ExistSocial
    },

    mixins: [topAppBarMixin],
    
    data() {
        return {
            staticMode: true
        }
    },
    watch: {
        '$route': {
            handler: function(to, from) {
                if (to.name === 'JoinComplete' || to.name === 'Join2CompleteApproved' || to.name === 'Join2CompleteUnapproved') {
                    this.setTopAppBarTitleOnly('')
                }else {
                    this.setTopAppBarBackOnly('')
                }
            },
            deep: true,
            immediate: true
        }
    },

    mounted() {
    },

    methods: {
        setTopAppBarBackOnly(title) {
            this.leftBtnMode = 'arrow_back'
            this.rightBtnMode = ''
            this.title = title || this.title
            this.leftBtnMethod = () => {
                if (this.$route.name === 'JoinIntro' || this.$route.name === 'Join2Intro') {
                    this.$router.push('/home')
                }else {
                    this.$router.go(-1)
                }
            }
            this.rightBtnMethod = ''
        },

        setTopAppBarCloseOnly(title) {
            this.leftBtnMode = 'close'
            this.rightBtnMode = ''
            this.title = title || this.title
            this.leftBtnMethod = () => {
                this.$router.push('/home')
                //this.moveParentRouter()
            }
            this.rightBtnMethod = ''
        },
    }

    
}
</script>